import { CellPopover } from '@components/CellPopover';
import useFormatter from '@hooks/useFormatter';
import { ICellPopover } from '@hooks/useCellPopover';
import { Box, makeStyles, Typography } from '@material-ui/core';
import IFatura from '@model/Fatura';
import React from 'react';

export type FaturaCanceladaPopoverProps = {
    fatura: IFatura
    cellPopover: ICellPopover<IFatura>
}

export function FaturaCanceladaPopover ({ fatura, cellPopover }: FaturaCanceladaPopoverProps) {
    const formatter = useFormatter();
    const cls = useStyles();

    return (
        <CellPopover
            cellPopover={cellPopover}
        >
            <Box className={cls.root}>
                <Typography>Data do Cancelamento: {formatter.toDateTime(fatura.dataHoraCancelamento)}</Typography>
                <Typography>{fatura.justificativaCancelamento}</Typography>
            </Box>
        </CellPopover>
    )
}

const useStyles = makeStyles(theme => ({
    root : {
        padding: theme.spacing(2)
    }
}));